import { Component, ViewChild, OnInit, Output, ViewEncapsulation, Input, HostListener, EventEmitter, ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { Repository, WindowRef } from '../../../services/repository'
import { NgSelectComponent } from '@ng-select/ng-select';
import {
  Lists_loaikhoan, Lists_tieumuc, Lists_nguonkinhphi, Lists_danhmuccapdonvi
  , Ultil_donvi, Lists_danhmuckhoxangdau
} from '../../../routes/menu'
import 'jquery'
import 'bootstrap'

import { DomSanitizer } from '@angular/platform-browser';
import { ModalComponent } from 'ng2-bs3-modal/ng2-bs3-modal';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';

import * as CodeMirror from 'codemirror';
import 'codemirror/mode/javascript/javascript';
import 'codemirror/mode/css/css.js';
import 'codemirror/mode/htmlmixed/htmlmixed.js';



const swal = require('sweetalert');
@Component({
  selector: 'app-danhmuc-khoxangdauedit',
  templateUrl: './khoxangdauedit.component.html',
  //templateUrl: 'ClientApp/routes/DanhMuc/data/data.component.html',
  styleUrls: ['./khoxangdauedit.component.scss'],
  providers: [ListService, Repository, WindowRef],
  encapsulation: ViewEncapsulation.None
})


export class khoxangdaueditComponent implements OnInit {
  @ViewChild('modalchitietxd', { static: false }) modal: ModalComponent;
  @ViewChild('dtechitietxd', { static: false }) doituongchungedit: any;

  inputtinhs: any;
  inputxaphuongs: any;
  inputdonvis: any;
  inputloaigiaypheps: any;
  inputnhomgiaypheps: any;
  public ngaybatdau: Date = null;
  public ngayketthuc: Date = null;
  inputhinhthucs: any =
    [{ Id: 0, Ten: 'Sử dụng nội bộ' }
      , { Id: 1, Ten: 'Cho thuê' }];

  inputtrangthais: any =
    [{ Id: 0, Ten: 'Hoạt động' }
      , { Id: 1, Ten: 'Kết thúc' }];

  quyen_them: boolean = false;
  quyen_sua: boolean = false;
  quyen_xoa: boolean = false;
  inputloaicauhois: any
  indLoading: boolean = false;
  doituongSelect: any = {
     Id: null,
    DonViId: null,
      TenKho: null,
      Tinh: null,
      Xa: null,
      DiaChiChiTiet: null,
      TongDungTich: null,
      GhiChu: null
      , Created: null
    , CreatedBy: null
    , Modified: null
    , ModifiedBy: null
    , ChiTiets: []

  };
  nhomdtid: string = null;
  hoatdong: string = null;
  inputloais: any = [{ Id: 0, Ten: 'Đúng sai' }, { Id: 1, Ten: 'Một lựa chọn' }, { Id: 2, Ten: 'Nhiều lựa chọn' }, { Id: 3, Ten: 'Tự luận' }]

  inputhinhthucthanhtoans: any = [{ Id: 0, Ten: 'Thanh toán tại nhà' }, { Id: 1, Ten: 'Chuyển khoản' }]

  inputmonhocs: any;
  inputloaikhoanluongs: any = [{ Id: 1, Name: 'Thu nhập thường xuyên' }, { Id: 2, Name: 'Thu nhập không thường xuyên' }, { Id: 3, Name: 'Khấu trừ thường xuyên' }, { Id: 4, Name: 'Khấu trừ không thường xuyên' }]
  inputloaikieunhaps: any = [{ Id: 1, Name: 'Số tiền' }, { Id: 2, Name: 'Tỷ lệ (%)' }, { Id: 3, Name: 'Hệ số' }]
  inputloaikhoans: any;
  inputloaithis: any;
  inputtaikhoantaisans: any;
  inputmucdocauhois: any;
  inputhuyens: any;
  inputxas: any;

  file: any;
  idnew: string;
  hienthianh: any;

  @Output() save: EventEmitter<any> = new EventEmitter();

  public ngxCurrencyOptions = {
    prefix: '',
    thousands: '.',
    decimal: ',',
    precision: 0,
    allowNegative: false
  };

  comboSearchFn_DV(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ten.toLowerCase().indexOf(term) > -1;
  }
  constructor(private _dataService: ListService, public repo: Repository, private sanitizer: DomSanitizer) {


  }
  transformYourHtml(htmlTextWithStyle) {
    return this.sanitizer.bypassSecurityTrustHtml(htmlTextWithStyle);
  }
  ngOnInit(): void {
    //document.getElementById('target').classList.add('upload-dialog1');
    //document.getElementById('defaultfileupload').style.display = 'none';
  }
  public ngonngu(text: string) {
    return this.repo.NgonNgu(text);
  }
  ngAfterViewInit() {
    //setTimeout(() => {
    //  this.rteObj.refreshUI(); // làm editor render lại hoàn toàn
    //  this.rteObj.toolbarModule.refreshToolbarOverflow();
    //}, 400);
  } 




  // @HostListener('document:keydown', ['$event'])
  // public handleKeyboardEvent(event: KeyboardEvent): void {

  //   if(event.key==="F9")
  //   {
  //       this.saveproduct();
  //   }
  //   event.stopPropagation();

  // }

  comboSearchFn(term: string, item: any) {
    term = term.toLowerCase();
    return  item.Ten.toLowerCase().indexOf(term) > -1;
  }
  @ViewChild("mafocus", { static: false }) mafocus: ElementRef;
  bnguonkinhphi: boolean = false;
  public dviid: string;
  bledit: boolean = false;
  currentUser: any;
  tudanhsach: number;
  khoahocid: number;

  public changeTinh($event: any) {
    if (typeof $event === "undefined") {
      this.doituongSelect.Tinh = null;
      this.doituongSelect.Xa = null;
    }
    else {
      this.doituongSelect.Tinh = $event.Id;
      this.doituongSelect.Xa = null;
      this.repo.postRequest('api/donvibanle/getxaphuong', { UserName: this.currentUser.user_name, TinhId: this.doituongSelect.Tinh })
        .subscribe(response => {
          this.inputxaphuongs = response;
        });
    }
  }
  comboSearchFn2(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ten.toLowerCase().indexOf(term) > -1;
  }
  rowdata: any = { Id: null, DuocSua: true, DonViSoHuu: null};
  loadDataInit(nhomdoituongid: string, row: any, donviid: string, khoahocid: number, tudanhsach: number) {
    this.nhomdtid = nhomdoituongid || Lists_danhmuckhoxangdau.id;
    this.tudanhsach = tudanhsach;
    this.khoahocid = khoahocid;
    //this.repo.postRequest("api/khoahoc/gettinh/", { Id: 1 })
    //  .subscribe(response => {
    //    this.inputtinhs = response;
    //  });
    if (row != null)
      this.rowdata = row;
    else
      this.rowdata = { Id: null, DuocSua: true, DonViSoHuu: null };
    this.dviid = donviid;
    var authlogin = localStorage.getItem('currentUser');
    if (authlogin) {
      let data = JSON.parse(authlogin);
      this.currentUser = data;
      var giatri = data.ds_quyen.filter(name => name.Id === Lists_danhmuckhoxangdau.id.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        if (giatri[0].Them == true)
          this.quyen_them = true;
        else
          this.quyen_them = false;
        if (giatri[0].Sua == true)
          this.quyen_sua = true;
        else
          this.quyen_sua = false;
        if (giatri[0].Xoa == true)
          this.quyen_xoa = true;
        else
          this.quyen_xoa = false;
      }
    }
    setTimeout(() => {
      this.mafocus.nativeElement.focus();
    }, 500);

    //this.doituongSelect.AnhString = null;
    this.hienthianh = false;
    $('#preview').attr('src', "/assets/img/anhdt.gif");

    this.repo.postRequest("api/kybaocao/getnhomgiayphep/", { UserName: this.currentUser.user_name })
      .subscribe(response => {
        this.inputnhomgiaypheps = response;
      });
    this.repo.postRequest("api/kybaocao/getloaigiayphep/", { UserName: this.currentUser.user_name })
      .subscribe(response => {
        this.inputloaigiaypheps = response;
      });

    this.repo.postRequest("api/donvibanle/gettinh/", { Id: this.rowdata.Id, UserName: this.currentUser.user_name })
      .subscribe(response => {
        this.inputtinhs = response;
      });

    this.repo.postRequest("api/baselayout/DonViChaPhanQuyen_GiayPhep_Read", { UserName: this.currentUser.user_name })
      .subscribe(response => {
        this.inputdonvis = response;
      });
    

    this.doituongSelect = {
      Id: null,
      DonViId: null,
      TenKho: null,
      Tinh: null,
      Xa: null,
      DiaChiChiTiet: null,
      TongDungTich: null,
      GhiChu: null
      , Created: null
      , CreatedBy: null
      , Modified: null
      , ModifiedBy: null
      , ChiTiets: []

    };
    this.ngaybatdau = null;
    this.ngayketthuc = null;

    if (donviid != null)
      this.doituongSelect.DonViId = parseInt(donviid);
    else
      this.doituongSelect.DonViId = parseInt(this.currentUser.id_don_vi);

    

    
    if (row === null) {

      this.bledit = false;
      this.doituongSelect.Created = new Date();
      this.doituongSelect.Modified = new Date();
      if (this.currentUser !== null) {
        this.doituongSelect.CreatedBy = this.currentUser.user_name;
        this.doituongSelect.ModifiedBy = this.currentUser.user_name;
      }

      this.doituongSelect.TrangThai = true;
      this.doituongSelect.ChiTiets = [];
      

    }
    else {
      this.bledit = true;
      console.log("t11");
      this.repo.getRequest("api/khoxangdau/getmodel/" + row.Id)
        .subscribe(response => {
          this.doituongSelect.Id = row.Id;

          this.doituongSelect.DonViId = response.DonViId;
          this.doituongSelect.TenKho = response.TenKho;
          this.doituongSelect.Tinh = response.Tinh;
          this.doituongSelect.Xa = response.Xa;
          this.doituongSelect.DiaChiChiTiet = response.DiaChiChiTiet;
          this.doituongSelect.TongDungTich = response.TongDungTich;
          this.doituongSelect.GhiChu = response.GhiChu;
         
          if (response.Created != null)
            this.doituongSelect.Created = new Date(response.Created);
          else
            this.doituongSelect.Created = new Date();
          this.doituongSelect.CreatedBy = response.CreatedBy;

          
          if (response.Modified != null)
            this.doituongSelect.Modified = new Date(response.Modified);
          else
            this.doituongSelect.Modified = new Date();
          this.doituongSelect.ModifiedBy = response.ModifiedBy;


          if (this.doituongSelect.Tinh != null) {
            this.repo.postRequest('api/donvibanle/getxaphuong', { UserName: this.currentUser.user_name, TinhId: this.doituongSelect.Tinh })
              .subscribe(response => {
                this.inputxaphuongs = response;
              });
          }

          if (response.ChiTiets != null) {
            this.doituongSelect.ChiTiets = response.ChiTiets;

            this.doituongSelect.ChiTiets.forEach(
              (item) => {
                if (item.NgayBatDau != null)
                  item.NgayBatDau = new Date(item.NgayBatDau);
                if (item.NgayKetThuc != null)
                  item.NgayKetThuc = new Date(item.NgayKetThuc);
                if (item.HopDongs != null) {
                  item.HopDongs.forEach((item1) => {
                    if (item1.NgayBatDau != null)
                      item1.NgayBatDau = new Date(item1.NgayBatDau);
                    if (item1.NgayKetThuc != null)
                      item1.NgayKetThuc = new Date(item1.NgayKetThuc);
                  });
                }
                if (item.TonKhos != null) {
                  item.TonKhos.forEach((item1) => {
                    if (item1.Ngay != null)
                      item1.Ngay = new Date(item1.Ngay);
                  });
                }

              }
            );



          }


          //setTimeout(() => {
          //  this.rteObj.refreshUI(); // làm editor render lại hoàn toàn
          //  this.rteObj.toolbarModule.refreshToolbarOverflow();
          //}, 400);



        });
    }

  

  }
  
  maxcot: number = 7;
  keyComBoPress(event: any, hang: number, cot: number, luoi: number) {
    if (event.which === 13) {
      cot = cot + 1;

      if (cot > this.maxcot) {
        hang = hang + 1;
        cot = 1;
        if (luoi === 1) {
          if (hang === this.doituongSelect.ChiTiets.length) {
            this.AddRowNew(this.doituongSelect.ChiTiets);
          }
        }
        

      }

      //this.setComboFocus(hang, cot, luoi);
      //event.preventDefault();
    }
  }
  //setComboFocus(hang: number, cot: number, luoi: number) {
  //  var tencombo: string = hang + '_' + cot + '_' + luoi;
  //  var ketqua = false;

  //  this.slcombo.forEach(
  //    (question) => {
  //      if (question.labelForId === tencombo) {

  //        ketqua = true;
  //        question.focus();
  //      }
  //    }
  //  );

  //  if (ketqua === false) {
  //    this.divs.forEach(
  //      (div) => {

  //        if (div.nativeElement.id === tencombo) {
  //          ketqua = true;
  //          div.nativeElement.focus();
  //        }

  //      }
  //    );
  //  }
  //}

  deleterow_XD(index: string, luoi: number) {
    console.log(index);
    swal({
      title: 'Bạn muốn xóa dòng này phải không?',
      text: 'Dữ liệu xóa sẽ không phục hồi lại được!',
      icon: "warning",
      buttons: {
        cancel: {
          text: 'Hủy bỏ',
          value: false,
          visible: true,
        },
        confirm: {
          text: 'Đồng ý',
          value: true,
          visible: true,
          className: "bg-danger",
          closeModal: true
        }
      }
    })
      .then(willDelete => {
        if (willDelete) {
            this.doituongSelect.ChiTiets.splice(index, 1);
        }
      });
  }

  RowNewClick() {
      this.AddRowNew(this.doituongSelect.ChiTiets);
  }
  AddRowNew(ctiets: any) {
    var sp = 'bottom';
    if (ctiets.length > 9)
      sp = 'top'
    if (ctiets.length > 0) //trường hợp lớn hơn 1 thì copy dòng cuối
    {
      var row = ctiets[ctiets.length - 1];

      ctiets.push({
        showpopup: sp, Id: null, KhoId: this.doituongSelect.Id, HinhThuc: row.HinhThuc,
        ThuongNhanThueId: null, BonBe: null, TongDungTich: null
        , NgayBatDau: null, NgayKetThuc: null, TrangThai: null, GhiChu: null, HopDongs:[], TonKho: []
      });
    }
    else {
      ctiets.push({
        showpopup: sp, Id: null, KhoId: this.doituongSelect.Id, HinhThuc: null,
        ThuongNhanThueId: null, BonBe: null, TongDungTich: null
        , NgayBatDau: null, NgayKetThuc: null, TrangThai: null, GhiChu: null, HopDongs: [], TonKho: []
      });

    }

  }

  index: number;

  editdata(row: any, index: number) {
    this.index = index;
    this.doituongchungedit.loadDataInit(Lists_danhmuckhoxangdau.id, row.Id, this.doituongSelect.DonViId, row);
    this.modal.open();
  }
  saveModal(row: any) {
    if (row != null) {
      this.doituongSelect.ChiTiets[this.index] = row;
    }
    this.modal.dismiss();
  }


  adddata_donvi() {

    this.doituongchungedit.loadDataInit(Ultil_donvi.id, null, this.dviid);
    this.modal.open();
  }
  //saveModal(doituong: any) {
  //  if (doituong != null) {
  //    this.inputdonvis.push({
  //      Id: doituong.Id, Ten: doituong.Ten, Ma: doituong.Ma
  //    })
  //    this.inputdonvis = this.inputdonvis.slice();
  //    this.doituongSelect.DonViId = doituong.Id;
  //  }
  //  this.modal.dismiss();
  //}

  Tai_Anh() {

    this.doituongSelect.XoaAnh = 1;
    $("#File").click();
  }
  Xoa_Anh() {

    this.doituongSelect.XoaAnh = 0;
    $('#preview').attr('src', "/assets/img/anhdt.gif");
  }
  getFiles(event) {
    console.log("tt");
    //console.log(event);
    this.file = event.target.files;
    if (!this.file[0].type.match("image.*")) {
      alert("Tệp chọn không phải kiểu ảnh.");
      event.srcElement.value = null;
      return;
    }

    var reader = new FileReader();
    reader.onload = this._handleReaderLoaded.bind(this);
    reader.readAsBinaryString(this.file[0]);

  }
  _handleReaderLoaded(readerEvt) {
    var binaryString = readerEvt.target.result;
    this.doituongSelect.AnhString = btoa(binaryString);  // Converting binary string data.

    $('#preview').attr('src', "data:image/png;base64," + this.doituongSelect.AnhString + "");

  }
  //  keyTenPress(event: any) { 
  //      if (event.which === 13) {
  //        this.slLoaiKhoanLuong.focus();
  //          event.preventDefault();
  //        }
  //}

  public closeModal() {
    this.save.emit(null);
  }
  public saveproduct() {
    
    this.doituongSelect.Modified = new Date();
    this.doituongSelect.ModifiedBy = this.currentUser.user_name;

    
    if (this.doituongSelect.DonViId == null) {
      swal('Lỗi!', 'Vui lòng nhập đơn vị sở hữu!.', 'error');
      return;
    }
    if (this.doituongSelect.TenKho == null) {
      swal('Lỗi!', 'Vui lòng nhập tên kho!.', 'error');
      return;
    }
   
    if (this.doituongSelect.Tinh == null) {
      swal('Lỗi!', 'Vui lòng nhập thông tin tỉnh!.', 'error');
      return;
    }
    

    this.repo.postRequest("api/khoxangdau/addorupdate", this.doituongSelect)
      .subscribe(response => {
        console.log(response);
        if (response != null && response.match('-')) {
          this.doituongSelect.Id = response;
          this.save.emit(this.doituongSelect);
        }
        else
          swal('Cảnh báo!', response, 'warning');

      });
  }

  exportTableToExcel4(): void {
    const table = document.getElementById('fixTable4');
    if (!table) return;

    const worksheet: XLSX.WorkSheet = XLSX.utils.table_to_sheet(table);
    const range = XLSX.utils.decode_range(worksheet['!ref']!);

    // --- Xác định cột tiền dựa vào header (dòng đầu) ---
    const moneyColumnIndexes: number[] = [];
    for (let C = range.s.c; C <= range.e.c; ++C) {
      const headerCellRef = XLSX.utils.encode_cell({ r: 0, c: C });
      const headerCell = worksheet[headerCellRef];
      if (!headerCell || !headerCell.v) continue;

      const headerText = headerCell.v.toString().toLowerCase();
      // Nếu header chứa từ khóa "lớp", "tiền", "tổng", coi là cột số
      if (headerText.includes('đã thu') || headerText.includes('học phí')
        || headerText.includes('giảm giá') || headerText.includes('tiền')
        || headerText.includes('phải thu') || headerText.includes('được giảm')
        || headerText.includes('còn thiếu')
      ) {
        moneyColumnIndexes.push(C);
      }
    }

    const allRows = table.querySelectorAll('tr'); // NodeList tất cả <tr>
    // --- Duyệt các hàng, chỉ convert cột tiền ---
    for (let R = 1; R < allRows.length; ++R) { // bỏ header
      const row = allRows[R];
      const cells = row.querySelectorAll('td, th');

      for (const C of moneyColumnIndexes) {
        const cellElement = cells[C];
        if (!cellElement) continue;

        const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
        const cell = worksheet[cellRef];
        if (!cell || !cell.v) continue;

        const dataValue = cellElement.getAttribute('data-value');
        let val: number;
        if (dataValue) val = Number(dataValue);
        else val = Number(cell.v.toString().replace(/\./g, ''));

        cell.v = val;
        cell.t = 'n';
      }
    }

    // --- Tạo workbook và xuất file ---
    const workbook: XLSX.WorkBook = { Sheets: { 'Sheet1': worksheet }, SheetNames: ['Sheet1'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const data: Blob = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
    FileSaver.saveAs(data, 'exported-table.xlsx');
  }


}

